/**
 * The keys `ps-data-table`'s row treats as "select this row": it calls
 * `preventDefault()` + `toggleSelected()` on a keydown of either, for ANY
 * target that bubbled up from a cell (`data-table.wc.ts`, the `ps-table-row`
 * keydown handler). Mirrors that check, `e.code === 'Space'` included.
 */
export const isRowActivationKey = (e: KeyboardEvent) =>
  e.key === 'Enter' || e.key === ' ' || e.code === 'Space';

/**
 * Keeps a control's own activation keys inside a table cell away from the row.
 * Without it the row's `preventDefault()` cancels the control's native
 * activation (so Enter / Space do nothing) and toggles the row instead. Only
 * these two keys are stopped: Escape and the rest must still reach the
 * document-level keydown listener an open `ps-dropdown` / `ps-popover` closes
 * on (`popover-base.wc.ts`, `addOpenListeners`).
 */
export const stopRowKeyActivation = (e: KeyboardEvent) => {
  if (isRowActivationKey(e)) e.stopPropagation();
};
